import React, { useState, useEffect } from 'react';
import api from '../api';
import { todayLocalStr } from '../utils/dateUtils';

export default function Dashboard() {
  const [data, setData] = useState(null);
  const [startDate, setStartDate] = useState(todayLocalStr());
  const [endDate, setEndDate] = useState(todayLocalStr());

  useEffect(() => { fetchDashboard(); }, []);

  const fetchDashboard = async () => {
    try {
      const res = await api.get('/dashboard?startDate=' + startDate + '&endDate=' + endDate);
      setData(res.data);
    } catch (err) { console.error(err); }
  };

  const fmt = (n) => '₹' + (n || 0).toLocaleString('en-IN');

  return (
    <div>
      <div style={{ background: 'white', borderRadius: 8, padding: 16, marginBottom: 24, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'end' }}>
          <div>
            <label style={{ display: 'block', fontSize: 14, fontWeight: 500, color: '#374151', marginBottom: 4 }}>Start Date</label>
            <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} style={{ border: '1px solid #d1d5db', borderRadius: 8, padding: '8px 12px' }} />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: 14, fontWeight: 500, color: '#374151', marginBottom: 4 }}>End Date</label>
            <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} style={{ border: '1px solid #d1d5db', borderRadius: 8, padding: '8px 12px' }} />
          </div>
          <div>
            <button onClick={fetchDashboard} style={{ background: '#2563eb', color: 'white', border: 'none', padding: '10px 24px', borderRadius: 8, cursor: 'pointer' }}>Apply</button>
          </div>
        </div>
      </div>

      {data && (
        <>
          {/* Expected - Highlighted */}
          <div style={{ background: 'linear-gradient(135deg, #7c3aed, #a855f7)', borderRadius: 12, padding: 28, color: 'white', marginBottom: 20, boxShadow: '0 6px 20px rgba(124,58,237,0.3)' }}>
            <p style={{ fontSize: 15, opacity: 0.9, margin: 0 }}>Expected This Month</p>
            <p style={{ fontSize: 40, fontWeight: 'bold', margin: '8px 0 0 0' }}>{fmt(data.expected)}</p>
            <p style={{ fontSize: 13, opacity: 0.8, margin: '4px 0 0 0' }}>Total interest receivable from all active loans this month</p>
          </div>

          {/* Main Cards */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14, marginBottom: 20 }}>
            <div style={{ background: '#10b981', borderRadius: 10, padding: 18, color: 'white' }}>
              <p style={{ fontSize: 13, opacity: 0.9, margin: 0 }}>Collections</p>
              <p style={{ fontSize: 22, fontWeight: 'bold', margin: '6px 0 0 0' }}>{fmt(data.totalCollections)}</p>
              <p style={{ fontSize: 11, opacity: 0.7, margin: '2px 0 0 0' }}>Interest collected</p>
            </div>
            <div style={{ background: '#3b82f6', borderRadius: 10, padding: 18, color: 'white' }}>
              <p style={{ fontSize: 13, opacity: 0.9, margin: 0 }}>Total Income</p>
              <p style={{ fontSize: 22, fontWeight: 'bold', margin: '6px 0 0 0' }}>{fmt(data.totalIncome)}</p>
              <p style={{ fontSize: 11, opacity: 0.7, margin: '2px 0 0 0' }}>Collections + Advance</p>
            </div>
            <div style={{ background: '#6366f1', borderRadius: 10, padding: 18, color: 'white' }}>
              <p style={{ fontSize: 13, opacity: 0.9, margin: 0 }}>Disbursements</p>
              <p style={{ fontSize: 22, fontWeight: 'bold', margin: '6px 0 0 0' }}>{fmt(data.totalDisbursements)}</p>
              <p style={{ fontSize: 11, opacity: 0.7, margin: '2px 0 0 0' }}>Loans given</p>
            </div>
            <div style={{ background: '#ef4444', borderRadius: 10, padding: 18, color: 'white' }}>
              <p style={{ fontSize: 13, opacity: 0.9, margin: 0 }}>Expenses</p>
              <p style={{ fontSize: 22, fontWeight: 'bold', margin: '6px 0 0 0' }}>{fmt(data.totalExpenses)}</p>
            </div>
            <div style={{ background: '#b91c1c', borderRadius: 10, padding: 18, color: 'white' }}>
              <p style={{ fontSize: 13, opacity: 0.9, margin: 0 }}>Capital Written Off</p>
              <p style={{ fontSize: 22, fontWeight: 'bold', margin: '6px 0 0 0' }}>{fmt(data.totalWrittenOff)}</p>
              <p style={{ fontSize: 11, opacity: 0.7, margin: '2px 0 0 0' }}>Unrecovered principal from Mark Off</p>
            </div>
            <div style={{ background: '#f59e0b', borderRadius: 10, padding: 18, color: 'white' }}>
              <p style={{ fontSize: 13, opacity: 0.9, margin: 0 }}>Pending</p>
              <p style={{ fontSize: 22, fontWeight: 'bold', margin: '6px 0 0 0' }}>{fmt(data.pendingCollections)}</p>
              <p style={{ fontSize: 11, opacity: 0.7, margin: '2px 0 0 0' }}>Overdue before today</p>
            </div>
            <div style={{ background: '#0891b2', borderRadius: 10, padding: 18, color: 'white' }}>
              <p style={{ fontSize: 13, opacity: 0.9, margin: 0 }}>Cash in Hand</p>
              <p style={{ fontSize: 22, fontWeight: 'bold', margin: '6px 0 0 0' }}>{fmt(data.cashInHand)}</p>
            </div>
          </div>

          {/* Net Income and Net Position -- two separate metrics (split apart
              2026-07-30) so capital you inject via Accounts "Add Money" and
              then disburse as loans doesn't look like a monthly loss. */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 14, marginBottom: 20 }}>
            <div style={{ background: data.netIncome >= 0 ? '#10b981' : '#ef4444', borderRadius: 10, padding: 18, color: 'white' }}>
              <p style={{ fontSize: 13, opacity: 0.9, margin: 0 }}>Net Income</p>
              <p style={{ fontSize: 26, fontWeight: 'bold', margin: '6px 0 0 0' }}>{fmt(data.netIncome)}</p>
              <p style={{ fontSize: 11, opacity: 0.7, margin: '4px 0 0 0' }}>Total Income − Expenses</p>
            </div>
            <div style={{ background: '#334155', borderRadius: 10, padding: 18, color: 'white' }}>
              <p style={{ fontSize: 13, opacity: 0.9, margin: 0 }}>Net Position</p>
              <p style={{ fontSize: 26, fontWeight: 'bold', margin: '6px 0 0 0' }}>{fmt(data.netPosition)}</p>
              <p style={{ fontSize: 11, opacity: 0.7, margin: '4px 0 0 0' }}>Loans Disbursed − Capital Paid − Marked Off</p>
            </div>
          </div>

          {/* User Balances */}
          {data.userBalances && data.userBalances.length > 0 && (
            <div style={{ background: 'white', borderRadius: 10, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', marginBottom: 20 }}>
              <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>Collector Balances</h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 10 }}>
                {data.userBalances.map((u, i) => (
                  <div key={i} style={{ background: '#f8fafc', borderRadius: 8, padding: 14, border: '1px solid #e2e8f0' }}>
                    <p style={{ fontSize: 14, fontWeight: 500, margin: 0 }}>{u.full_name || u.username}</p>
                    <p style={{ fontSize: 20, fontWeight: 'bold', color: '#7c3aed', margin: '4px 0 0 0' }}>{fmt(u.total_balance)}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Active Loans + Customers */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <div style={{ background: 'white', borderRadius: 8, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
              <h3 style={{ fontSize: 16, fontWeight: 600 }}>Active Loans</h3>
              <p style={{ fontSize: 40, fontWeight: 'bold', color: '#2563eb' }}>{data.activeLoans}</p>
            </div>
            <div style={{ background: 'white', borderRadius: 8, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
              <h3 style={{ fontSize: 16, fontWeight: 600 }}>Total Customers</h3>
              <p style={{ fontSize: 40, fontWeight: 'bold', color: '#7c3aed' }}>{data.totalCustomers}</p>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
